// Checkout of the Polish Impultienda store (wizualnyatlas). The root URL shows the store's active funnel.
export const checkoutUrl = 'https://wizualnyatlas.impultienda.ar'

export { gallery, heroImage } from './media'
export type { GalleryItem } from './media'

export const siteMeta = {
  lang: 'pl',
  title: 'Wizualny Atlas Biomechaniki Ćwiczeń — 100 map dla trenerów personalnych',
}

export const brand = {
  eyebrow: 'Dla trenerów personalnych i instruktorów siłowni',
  headline: '100 ćwiczeń już przeanalizowanych.',
  headlineAccent: 'Przestań szukać wyjaśnień w filmikach i podręcznikach.',
  name: 'Wizualny Atlas Biomechaniki Ćwiczeń',
  subheadline: '100 map wizualnych + 6 praktycznych bonusów',
  description:
    'Zaangażowane mięśnie, płaszczyzny anatomiczne, prawidłowe wykonanie, typowe błędy i warianty — wszystko uporządkowane na wizualnych mapach, do których zajrzysz w każdej chwili.',
  tagline: 'Wybierz. Otwórz. Wytłumacz z pewnością.',
}

export const heroCta = 'Chcę cały Atlas'

export const heroNote = 'Natychmiastowy dostęp · PDF do druku · Jednorazowa płatność'

export const heroGuarantee = '7 dni gwarancji zwrotu pieniędzy.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '100', label: 'Map wizualnych' },
  { value: '100', label: 'Przeanalizowanych ćwiczeń' },
  { value: '3', label: 'Obszary treningowe' },
  { value: '6', label: 'Praktycznych bonusów' },
]

export interface Situation {
  title: string
  text: string
}

export const situationsTitle = 'Rozpoznajesz te sytuacje?'

export const situationsIntro =
  'Jeśli pracujesz jako trener personalny, przynajmniej jedna z nich na pewno brzmi znajomo.'

export const situations: Situation[] = [
  {
    title: 'Klient zadaje ci pytanie z anatomii.',
    text: 'Znasz to ćwiczenie, ale jasne wytłumaczenie, które mięśnie pracują, nie zawsze przychodzi od razu.',
  },
  {
    title: 'Widzisz błąd techniczny, ale trudno ci go wyjaśnić.',
    text: 'Przydałby ci się konkretny punkt odniesienia, żeby rozłożyć ruch na części i dobrać korektę.',
  },
  {
    title: 'Tracisz czas między filmikami, książkami i notatkami.',
    text: 'Za każdym razem, gdy chcesz coś sprawdzić, przeszukujesz kilka różnych źródeł.',
  },
  {
    title: 'Znasz teorię, ale przełożenie jej na praktykę zajmuje czas.',
    text: 'Połączenie mięśni, płaszczyzn anatomicznych i realnych ćwiczeń nie zawsze jest proste.',
  },
]

export const situationsClosing =
  'Nie brakuje ci wiedzy. Brakuje ci wizualnego systemu, do którego zajrzysz, kiedy go potrzebujesz.'

export const comparisonCopy = {
  title: 'Od rozproszonych informacji do 100 uporządkowanych ćwiczeń.',
  oldEyebrow: 'Przed',
  oldLabel: 'Bez Atlasu',
  atlasEyebrow: 'Po',
  atlasLabel: 'Z Wizualnym Atlasem',
  closing: 'Mniej szukania. Więcej czasu dla twoich klientów.',
}

export const comparisonOld: string[] = [
  'Szukasz wyjaśnień w różnych filmikach i podręcznikach.',
  'Masz porozrzucane notatki o mięśniach i ruchach.',
  'Tracisz czas, szukając w kółko tych samych informacji.',
  'Teorię z ćwiczeniami musisz łączyć na własną rękę.',
]

export const comparisonAtlas: string[] = [
  '100 ćwiczeń przeanalizowanych i uporządkowanych.',
  'Mięśnie, technika i ruch na jednej mapie.',
  'Typowe błędy i warianty zawsze pod ręką.',
  'Anatomia połączona z realnymi ćwiczeniami.',
]

export interface DemoStep {
  number: string
  title: string
  text: string
}

export const demoCopy = {
  title: 'Klient zadaje pytanie. Ty masz gotową analizę pod ręką.',
  questionLabel: 'Klient pyta:',
  question: 'Jakie mięśnie pracują przy przysiadzie?',
}

export const demoSteps: DemoStep[] = [
  {
    number: '01',
    title: 'Wybierz',
    text: 'Otwórz dział Kończyny dolne i znajdź mapę przysiadu.',
  },
  {
    number: '02',
    title: 'Sprawdź',
    text: 'Przejrzyj zaangażowane mięśnie, technikę i najczęstsze błędy.',
  },
  {
    number: '03',
    title: 'Wytłumacz',
    text: 'Wykorzystaj analizę, żeby wyjaśnić klientowi wszystko jasno i konkretnie.',
  },
]

export const galleryCopy = {
  title: 'Zajrzyj do środka map.',
  subtitle:
    'Prawdziwe ćwiczenia przeanalizowane wizualnie, z najważniejszymi informacjami już uporządkowanymi.',
  footer: '100 przeanalizowanych ćwiczeń. Jeden system, gotowy do użycia.',
  cta: 'Chcę 100 map wizualnych',
}

export const systemCopy = {
  title: '100 ćwiczeń przeanalizowanych za ciebie.',
  subtitle: 'Kompletny system wizualny, podzielony na trzy obszary treningowe.',
  areaLabel: 'Obszar',
  includesTitle: 'Na każdej mapie znajdziesz:',
  closing:
    'To nie kolejny e-book z anatomii. To wizualne narzędzie, które pomaga zrozumieć i wytłumaczyć ćwiczenia.',
}

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  description: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Kończyny dolne',
    detail: '40 map wizualnych',
    summary: 'Przysiad, martwy ciąg, hip thrust, wykroki, suwnica i ich główne warianty.',
    description:
      'Zaangażowane mięśnie, technika i typowe błędy w najważniejszych ćwiczeniach na dolne partie ciała.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Kończyny górne',
    detail: '40 map wizualnych',
    summary: 'Wyciskanie, pompki, podciąganie, wiosłowanie, ściąganie drążka i ćwiczenia izolowane.',
    description: 'Wizualne analizy najważniejszych ruchów pchających i ciągnących.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Core i stabilizacja',
    detail: '20 map wizualnych',
    summary: 'Plank, dead bug, bird dog, ćwiczenia antyrotacyjne i kontrola lędźwiowo-miedniczna.',
    description: 'Stabilizacja, zaangażowane mięśnie i szczegóły ruchu.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Mięśnie główne i pomocnicze',
  'Mięśnie stabilizujące',
  'Płaszczyzny anatomiczne i łańcuchy kinematyczne',
  'Prawidłowe wykonanie',
  'Typowe błędy i możliwe korekty',
  'Warianty i praktyczne wskazówki',
]

export interface Bonus {
  tag: string
  title: string
  benefit: string
}

export const bonusesCopy = {
  title: 'Dodatkowo dostajesz 6 praktycznych bonusów.',
  subtitle: 'Dodatkowe narzędzia do analizowania, powtarzania i tłumaczenia ćwiczeń.',
  badge: 'W pakiecie',
  closing: 'Wszystkie 6 bonusów jest już w twoim Atlasie.',
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 01',
    title: 'Przewodnik „Bez blokady”',
    benefit: 'Praktyczne schematy, dzięki którym wytłumaczysz ćwiczenia jasno i po kolei.',
  },
  {
    tag: 'Bonus 02',
    title: '7-dniowy plan',
    benefit: 'Uporządkowana ścieżka, która utrwala analizę ćwiczeń.',
  },
  {
    tag: 'Bonus 03',
    title: 'Planer powtórek',
    benefit: 'Schematy powtórek: 7 dni, 3 dni i 24 godziny.',
  },
  {
    tag: 'Bonus 04',
    title: 'Checklista 60 sekund',
    benefit: 'Szybka sekwencja, by metodycznie przeanalizować każde ćwiczenie.',
  },
  {
    tag: 'Bonus 05',
    title: 'Zeszyt ćwiczeń',
    benefit: '20 ćwiczeń z przykładami analizy i wyjaśnienia.',
  },
  {
    tag: 'Bonus 06',
    title: 'Słowniczek ekspresowy',
    benefit: 'Mięśnie, ruchy i płaszczyzny anatomiczne wyjaśnione w prosty sposób.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

// Vacío a propósito: solo se cargan testimonios reales de compradores polacos.
export const testimonials: Testimonial[] = []

export const guaranteeCopy = {
  title: '7 dni gwarancji. Kupujesz bez ryzyka.',
  paragraphs: [
    'Przeglądaj mapy i wszystkie materiały z pakietu.',
    'Jeśli w ciągu 7 dni od zakupu uznasz, że Atlas nie spełnia twoich oczekiwań, możesz poprosić o zwrot pieniędzy zgodnie z warunkami gwarancji.',
  ],
  closing: 'Jedna płatność. Bez abonamentu. Dostęp na zawsze.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqTitle = 'Najczęściej zadawane pytania'

export interface Offer {
  title: string
  name: string
  summary: string
  includes: string[]
  price: string
  currency: string
  /** ISO code sent to the Meta pixel. */
  currencyCode: string
  cta: string
  note: string
}

export const offer: Offer = {
  title: 'Twój kompletny Wizualny Atlas. Wszystko w jednym zakupie.',
  name: 'Wizualny Atlas Biomechaniki Ćwiczeń',
  summary: '100 map wizualnych + 6 praktycznych bonusów',
  includes: [
    '100 przeanalizowanych ćwiczeń',
    '40 map: kończyny dolne',
    '40 map: kończyny górne',
    '20 map: core i stabilizacja',
    'Mięśnie, technika, błędy i warianty',
    'Wszystkie 6 bonusów w pakiecie',
    'PDF do druku',
    'Natychmiastowy dostęp na zawsze',
  ],
  price: '69',
  currency: 'zł',
  currencyCode: 'PLN',
  cta: 'Tak, chcę cały Atlas',
  note: 'Jednorazowa płatność · Bez abonamentu · 7 dni gwarancji',
}

export const faqs: FaqItem[] = [
  {
    question: 'Czy to sprawdzi się także u początkujących trenerów?',
    answer:
      'Tak. Mapy pomagają połączyć anatomię z realnymi ćwiczeniami i mogą służyć jako punkt odniesienia w rozwoju zawodowym.',
  },
  {
    question: 'Czy mogę korzystać z niego na telefonie w trakcie pracy?',
    answer:
      'Tak. Pliki PDF otworzysz na telefonie, tablecie lub komputerze, kiedy tylko chcesz przypomnieć sobie ćwiczenie.',
  },
  {
    question: 'Czy zawiera gotowe plany treningowe?',
    answer:
      'Nie. To system wizualnej analizy ćwiczeń, a nie zbiór spersonalizowanych planów treningowych.',
  },
  {
    question: 'Czy mogę wydrukować mapy?',
    answer: 'Tak. Wszystkie materiały otrzymujesz w formacie PDF gotowym do druku.',
  },
  {
    question: 'Jak otrzymam Atlas? Czy płacę co miesiąc?',
    answer: `Dostęp cyfrowy dostajesz zaraz po płatności. To jednorazowy zakup za ${offer.price} ${offer.currency}, bez abonamentu.`,
  },
  {
    question: 'A jeśli Atlas mi nie odpowiada?',
    answer: 'Możesz poprosić o zwrot pieniędzy w ciągu 7 dni, zgodnie z warunkami gwarancji.',
  },
]

export const finalCtaCopy = {
  title: '100 przeanalizowanych ćwiczeń. Gotowych, kiedy ich potrzebujesz.',
  subtitle:
    'Przestań szukać w kółko tych samych wyjaśnień. Mięśnie, technika, typowe błędy i warianty — uporządkowane w jednym Wizualnym Atlasie.',
  summary: '100 map wizualnych + 6 bonusów',
  cta: 'Chcę cały Atlas',
}

export const trustBadges = {
  access: 'Natychmiastowy dostęp',
  payment: 'Jednorazowa płatność',
  guarantee: '7 dni gwarancji',
}

// Not rendered (the sticky bar was removed); kept so the unused StickyCta file still compiles.
export const stickyCtaCopy = {
  label: 'Pełny Atlas + 6 zestawów',
  cta: 'Chcę Atlas',
}

export const galleryUi = {
  carousel: 'karuzela',
  galleryLabel: 'Galeria map wizualnych',
  imageAlt: (title: string) =>
    `Mapa wizualna: ${title} — mięśnie, płaszczyzny anatomiczne i najczęstsze błędy`,
  previous: 'Poprzednia mapa',
  next: 'Następna mapa',
  goTo: (title: string) => `Zobacz: ${title}`,
  hint: (current: number, total: number) =>
    `Przesuń lub użyj strzałek — ${current} z ${total} przykładowych map`,
}

export const footerCopy = {
  tagline: 'Materiał cyfrowy · Natychmiastowy dostęp · 7 dni gwarancji',
  rights: 'Wszelkie prawa zastrzeżone.',
  links: [
    { label: 'Regulamin', href: '#regulamin' },
    { label: 'Polityka prywatności', href: '#prywatnosc' },
    { label: 'Kontakt', href: '#kontakt' },
  ],
}

export const heroImageAlt =
  'Wizualny Atlas Biomechaniki Ćwiczeń: 100 map wizualnych + 6 profesjonalnych zestawów dla trenerów personalnych'
